import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import theme from "@/utils/theme";
Vue.use(Router);
let router = new Router({
  base: "/",
  // mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home/index",
    },
    {
      path: "/home/index",
      component: (resolve) => require(["@/views/home/index"], resolve),
      meta: {},
    },

    {
      path: "/home/test",
      component: (resolve) => require(["@/views/test/index"], resolve),
      meta: {
        title: "组件测试页面",
      },
    },
    {
      path: "/home/auth",
      component: (resolve) => require(["@/views/home/auth"], resolve),
      meta: {
        title: "实名登记",
      },
    },
    {
      path: "/home/addDevice",
      component: (resolve) => require(["@/views/home/addDevice"], resolve),
      meta: {
        title: "添加设备",
      },
    },
    {
      path: "/home/useList",
      component: (resolve) => require(["@/views/home/useList"], resolve),
      meta: {
        title: "使用记录",
      },
    },

    {
      path: "/home/discountSelection",
      component: (resolve) =>
        require(["@/views/home/discountSelection"], resolve),
      meta: {
        title: "优惠与折扣",
      },
    },
    {
      path: "/home/web",
      component: (resolve) => require(["@/views/home/web"], resolve),
      meta: {
        title: "实名登记",
      },
    },
    {
      path: "/home/manger",
      component: (resolve) => require(["@/views/home/manger"], resolve),
      meta: {
        title: "进入控制台",
      },
    },
    {
      path: "/home/chinaUnicom",
      component: (resolve) => require(["@/views/home/chinaUnicom"], resolve),
      meta: {
        title: "联通实名登记",
      },
    },
    {
      path: "/user/index",
      component: (resolve) => require(["@/views/user/index"], resolve),
      meta: {
        title: "用户中心",
      },
    },
    {
      path: "/user/agreement",
      component: (resolve) => require(["@/views/user/agreement"], resolve),
      meta: {
        title: "协议条款",
      },
    },
    {
      path: "/user/aboutus",
      component: (resolve) => require(["@/views/user/aboutus"], resolve),
      meta: {
        title: "关于我们",
      },
    },
    {
      path: "/user/info",
      component: (resolve) => require(["@/views/user/info"], resolve),
      meta: {
        title: "个人信息",
      },
    },
    {
      path: "/user/order",
      component: (resolve) => require(["@/views/user/order"], resolve),
      meta: {
        title: "我的订单",
      },
    },
    {
      path: "/user/freeOrder",
      component: (resolve) => require(["@/views/user/freeOrder"], resolve),
      meta: {
        title: "免押订单",
      },
    },
    {
      path: "/user/orderdetails",
      component: (resolve) => require(["@/views/user/orderdetails"], resolve),
      meta: {
        title: "订单详情",
      },
    },
    {
      path: "/user/orderrefund",
      component: (resolve) => require(["@/views/user/orderrefund"], resolve),
      meta: {
        title: "退款详情",
      },
    },
    // {
    //   path: "/home/firstRecharge",
    //   component: (resolve) => require(["@/views/home/firstRecharge"], resolve),
    //   meta: {
    //     title: "流量充值",
    //   },
    // },
    {
      path: "/control/login",
      component: (resolve) => require(["@/views/control/login"], resolve),
      meta: {
        title: "授权登录",
      },
    },
    {
      path: "/homeaddress/index",
      component: (resolve) => require(["@/views/homeaddress/index"], resolve),
      meta: {
        title: "捷电猫管家",
      },
    },
    {
      path: "/download/index",
      component: (resolve) => require(["@/views/download/index"], resolve),
      meta: {
        title: "下载",
      },
    },
    {
      path: "/home/deviceFree",
      component: (resolve) => require(["@/views/home/deviceFree"], resolve),
      meta: {
        title: "套餐赠送",
      },
    },
    {
      path: "/home/noDevice",
      component: (resolve) => require(["@/views/home/noDevice"], resolve),
      meta: {
        title: "流量充值",
      },
    }, //
    {
      path: "/home/associationDevice",
      component: (resolve) =>
        require(["@/views/home/associationDevice"], resolve),
      meta: {
        title: "关联设备",
      },
    },
    {
      path: "/home/updateBuy",
      component: (resolve) => require(["@/views/home/updateBuy"], resolve),
      meta: {
        title: "流量充值",
      },
    },
    {
      path: "/home/deviceInfor",
      component: (resolve) => require(["@/views/home/deviceInfor"], resolve),
      meta: {
        title: "设备信息",
      },
    },
    {
      path: "/home/InternetAuthentication",
      component: (resolve) =>
        require(["@/views/home/InternetAuthentication"], resolve),
      meta: {
        title: "上网认证",
      },
    },
    {
      path: "/home/InternetAuthList",
      component: (resolve) =>
        require(["@/views/home/InternetAuthList"], resolve),
      meta: {
        title: "认证列表",
      },
    },
    {
      path: "/home/enterMiniProgram",
      component: (resolve) =>
        require(["@/views/home/enterMiniProgram"], resolve),
      meta: {
        title: "确认订单",
      },
    },
    {
      path: "/zfbTip",
      component: (resolve) => require(["@/views/infor/tip"], resolve),
      meta: {
        title: "温馨提示",
      },
    },
    {
      path: "/zfbTipP0004",
      component: (resolve) => require(["@/views/infor/tip"], resolve),
      meta: {
        title: "温馨提示",
      },
    },
    {
      path: "/home/updateBuyOrder",
      component: (resolve) => require(["@/views/home/updateBuyOrder"], resolve),
      meta: {
        title: "套餐升级",
      },
    },
    {
      path: "/home/depositFreeDetail",
      component: (resolve) =>
        require(["@/views/home/depositFreeDetail"], resolve),
      meta: {
        title: "免押详情",
      },
    },
    {
      path: "/home/depositFreeFinnish",
      component: (resolve) =>
        require(["@/views/home/depositFreeFinnish"], resolve),
      meta: {
        title: "免押完结",
      },
    },
    {
      path: "/coupon/mangerCoupons",
      component: (resolve) =>
        require(["@/views/coupon/mangerCoupons"], resolve),
      meta: {
        title: "优惠券",
      },
    },
    {
      path: "/coupon/claimCoupon",
      component: (resolve) => require(["@/views/coupon/claimCoupon"], resolve),
      meta: {
        title: "领取优惠券",
      },
    },
    {
      path: "/coupon/coupon",
      component: (resolve) => require(["@/views/coupon/coupon"], resolve),
      meta: {
        title: "优惠券",
      },
    },
    {
      path: "/home/enterWX",
      component: (resolve) => require(["@/views/home/enterWX"], resolve),
      meta: {
        title: "绑定设备",
      },
    },
  ],
  // scrollBehavior(to, from, savedPosition) {
  //   // return 期望滚动到哪个的位置
  //   return { x: 0, y: 0 };
  // },
});

// 全局前置守卫，动态设置标题
router.beforeEach(async (to, from, next) => {
  // const title = to.meta.title;
  // if (title) {
  //   document.title = title; // 设置页面标题
  // }
  if (to.path === "/home/index") {
    const serverTheme = await theme.fetchTheme();
    document.title = serverTheme.name;
    if (serverTheme) {
      theme.setTheme(serverTheme);
    }
  } else {
    if (
      to.path !== "/homeaddress/index" &&
      to.path !== "/download/index" &&
      to.path !== "/zfbTip"
    ) {
      if (!store.state.appData) {
        const serverTheme = await theme.fetchTheme();
        if (serverTheme) {
          theme.setTheme(serverTheme);
        }
      }
    }
  }
  next();
});
export default router;
